import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { REST_ENPOINTS } from "../../../constants/enpoints";

const initialState = {
  currentChat: { chatRoomId: null, memberId: null },
  message: "",
  file: "",
  uploadPreview: null,
  isAdmin: true,
  isImage: false,
  uploadLoading: false,
  uploadError: null,
  updateMessage: { id: null, message: "" },
};

export const uploadMessageImage = createAsyncThunk(
  "chat/upload",
  async ({ handleClose }, thunkAPI) => {
    const { file } = thunkAPI.getState().chat;
    try {
      const res = await axios.post(REST_ENPOINTS.uploadChatImage, { file });
      handleClose();
      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setCurrentChat: (state, { payload }) => {
      state.currentChat = {
        chatRoomId: payload.id,
        memberId: payload.member.id,
        userId: payload.member.memberId,
        nickname: payload.member.nickname,
        profileImage: payload.member.profileImage,
        isBlocked: payload.member.isBlocked,
      };
      state.message = initialState.message;
    },
    onChangeMessage: (state, { payload }) => {
      state.message = payload;
    },
    clearMessage: (state) => {
      state.message = initialState.message;
    },
    setMessageImageFile: (state, { payload }) => {
      state.file = payload;
    },
    setMessageImagePreview: (state, { payload }) => {
      state.uploadPreview = payload;
    },
    removeMessageImage: (state) => {
      state.file = initialState.file;
      state.uploadPreview = initialState.uploadPreview;
    },
    updateCurrentChatBlock: (state, { payload }) => {
      state.currentChat = {
        ...state.currentChat,
        isBlocked: payload,
      };
    },
    setUpdateMessage: (state, { payload }) => {
      state.updateMessage = {
        id: payload.id,
        message: payload.message,
      };
    },
    onChangeUpdateMessage: (state, { payload }) => {
      state.updateMessage = { ...state.updateMessage, message: payload };
    },
    clearUpdateMessage: (state) => {
      state.updateMessage = initialState.updateMessage;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadMessageImage.pending, (state) => {
        state.uploadLoading = true;
      })
      .addCase(uploadMessageImage.fulfilled, (state) => {
        state.uploadLoading = false;
      })
      .addCase(uploadMessageImage.rejected, (state, action) => {
        state.uploadLoading = false;
        state.uploadError = action.payload;
      });
  },
});

export const {
  setCurrentChat,
  onChangeMessage,
  clearMessage,
  removeMessageImage,
  updateCurrentChatBlock,
  setUpdateMessage,
  onChangeUpdateMessage,
  clearUpdateMessage,
  setMessageImageFile,
  setMessageImagePreview,
} = chatSlice.actions;

export default chatSlice.reducer;
